import { Chat } from '@/config'
import { useChatBadgeCount } from '@packages/chat'
import { useChatContext } from 'stream-chat-react'

export const ChatGlobalListeners = () => {
  const { client } = useChatContext()
  useChatBadgeCount({ client })
  Chat.Hooks.useSyncUserUpdates(client, { enabled: !!client })
  Chat.Hooks.useExcludedWords()

  return null
}
